import { UtensilsCrossed, HeartPulse, BedDouble, Music, Store } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

const icons = {
  restaurants: UtensilsCrossed,
  wellness: HeartPulse,
  hotels: BedDouble,
  nightlife: Music,
  independent: Store,
};

export const Industries = () => {
  const { t } = useLang();
  return (
    <section className="bg-[#191713] py-20 lg:py-32" id="industries" data-testid="industries-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="eyebrow-label mb-6">{t.industries.eyebrow}</p>
          <h2 className="font-serif text-[#F7F3EC] text-3xl sm:text-4xl lg:text-5xl max-w-2xl">{t.industries.title}</h2>
          <p className="mt-4 text-[#9A9184] max-w-xl">{t.industries.sub}</p>
        </Reveal>
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#B8933F]/15">
          {t.industries.items.map((item, i) => {
            const Icon = icons[item.key];
            return (
              <Reveal key={item.key} delay={i * 0.06}>
                <article
                  className="bg-[#191713] hover:bg-[#23201A] transition-colors duration-300 p-8 lg:p-10 h-full group"
                  data-testid={`industry-card-${item.key}`}
                >
                  <Icon size={22} className="text-[#B8933F]" strokeWidth={1.5} />
                  <h3 className="mt-6 font-serif text-xl text-[#F7F3EC]">{item.name}</h3>
                  <p className="mt-4 text-sm text-[#9A9184] leading-relaxed">{item.problem}</p>
                  <div className="mt-5 pt-5 border-t border-[#B8933F]/15">
                    <p className="text-sm text-[#F7F3EC]/85 leading-relaxed">{item.answer}</p>
                  </div>
                </article>
              </Reveal>
            );
          })}
          <Reveal delay={0.3}>
            <div className="bg-[#23201A] p-8 lg:p-10 h-full flex flex-col justify-center">
              <p className="font-serif text-xl text-[#B8933F] italic leading-snug">
                {t.finalCta.title}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
